import React from 'react';
import ReviewsPropertyPerformanceTable
	from '@app/site/secured/review-manager/fragment/property-overview/component/ReviewsPropertyPerformanceTable';
import ReviewsCompetitiveAdvantagesOrGapsFragment
	from '@app/site/secured/review-manager/fragment/property-overview/_competitors/ReviewsCompetitiveAdvantagesOrGapsFragment';
import ReviewsCategoryPerformanceComparisonGraph
	from '@app/site/secured/review-manager/fragment/property-overview/component/graph/ReviewsCategoryPerformanceComparisonGraph';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';
import ReviewsSubCategoryGapAnalysisGraph
	from '@app/site/secured/review-manager/fragment/property-overview/component/graph/ReviewsSubCategoryGapAnalysisGraph';

const ReviewsCompetitorOverviewFragment: React.FunctionComponent<{
	mainHotelReviewsState: CompetitorReviewsState,
	competitorReviewsState: CompetitorReviewsState,
}>
	= ({ mainHotelReviewsState, competitorReviewsState }) => {

	return <>
		<div className="flex items-center mt-6">
			<div className="relative flex shrink-0 justify-start"><span
				className="bg-gray-100 text-sm font-light text-gray-500 pr-3">{competitorReviewsState.hotelName}</span>
			</div>
			<div aria-hidden="true" className="w-full border-t border-gray-300"></div>
		</div>
		<div className="grid grid-cols-1 gap-5 sm:grid-cols-2 mt-6">
			<div className="col-span-2">
				<ReviewsCompetitiveAdvantagesOrGapsFragment mainHotelReviewsState={mainHotelReviewsState}
																											competitorReviewsState={competitorReviewsState} />
			</div>
			<div className="col-span-2">
				<ReviewsPropertyPerformanceTable
					selectedHotelReviewsState={competitorReviewsState}
					comparisonHotelReviewsState={mainHotelReviewsState}
				/>
			</div>
			<div className="col-span-2 md:col-span-1">
				<div className="px-3 mb-1">
					<h2 className="text-base font-semibold text-gray-900">
						Category Performance Comparison
					</h2>
				</div>
				<div className=" overflow-hidden rounded-lg bg-white shadow border-gray-300 h-96">
					<ReviewsCategoryPerformanceComparisonGraph
						mainHotelReviewsState={mainHotelReviewsState}
						competitorReviewsState={competitorReviewsState}
					/>
				</div>
			</div>
			<div className="col-span-2 md:col-span-1">
				<div className="px-3 mb-1">
					<h2 className="text-base font-semibold text-gray-900">Gap Analysis</h2>
				</div>
				<div className="overflow-hidden rounded-lg bg-white shadow border-gray-300 h-96">
					<ReviewsSubCategoryGapAnalysisGraph
						mainHotelReviewsState={mainHotelReviewsState}
						competitorReviewsState={competitorReviewsState}
					/>
				</div>
			</div>
		</div>
	</>;
};

export default ReviewsCompetitorOverviewFragment;
